import { render, staticRenderFns } from "./LicenseBox.vue?vue&type=template&id=0340bfb7"
import script from "./LicenseBox.vue?vue&type=script&lang=js"
export * from "./LicenseBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports